import {useQuery, UseQueryResult} from "react-query";
import {AxiosError} from "axios";
import {IYear} from "../../../utils/interfaces/IYear";
import {API, ApiResponseBase, CustomAxiosError} from "../../../logics/api-config";


export interface ApiResponse extends ApiResponseBase {
    data: IYear[];
}


async function doGet(): Promise<IYear[]> {
    try {
        const response = await API.get(`/accounting/bills/monthly`);
        const responseData: ApiResponse = response?.data;
        return responseData.data;
    } catch (error) {
        throw error;
    }
}

const useApiGetMonthlyInvoices = (): UseQueryResult<IYear[], CustomAxiosError> => {
    return useQuery<IYear[], CustomAxiosError>("getMonthlyInvoices", doGet);
};


export default useApiGetMonthlyInvoices